/* eslint-disable no-prototype-builtins */
/* eslint-disable no-global-assign */
const warningColor = "orange";
export function isJSON(str) {
  if (str?.indexOf("{") != -1) {
    try {
      JSON.parse(str);
      return true;
    } catch (e) {
      return false;
    }
  } else {
    return false;
  }
}
export function getCurrentWeekRange() {
  const today = new Date();

  // Find Monday of the current week
  const day = today.getDay(); // 0 = Sunday, 1 = Monday, ..., 6 = Saturday
  const diffToMonday = day === 0 ? -6 : 1 - day;
  const monday = new Date(today);
  monday.setDate(today.getDate() + diffToMonday);

  // Find Sunday of the same week
  const sunday = new Date(monday);
  sunday.setDate(monday.getDate() + 6);

  // Format as MM/DD/YYYY
  const format = date => {
    const mm = date.getMonth() + 1;
    const dd = date.getDate();
    const yyyy = date.getFullYear();
    return `${mm}/${dd}/${yyyy}`;
  };

  return `${format(monday)} - ${format(sunday)}`;
}
export function queueOffline(data) {
  let queue = JSON.parse(localStorage.getItem("offline_queue") || "[]");

  const index = queue.findIndex(r => r.model?._id === data.model?._id);

  if (index !== -1) {
    queue[index] = data;
  } else {
    queue.push(data);
  }

  localStorage.setItem("offline_queue", JSON.stringify(queue));
}
export function combineMongoQueries(defaultQuery = {}, assistantQuery = {}) {
  const combined = {};
  const finalAnd = [];
  const finalExprAnd = [];

  function extractConditions(query) {
    const and = [];
    const expr = [];

    // Pull $and array
    if (Array.isArray(query.$and)) {
      and.push(...query.$and);
    }

    // Pull $expr.$and
    if (query.$expr?.$and) {
      for (const item of query.$expr.$and) {
        if ((item.$gte || item.$gt || item.$lte || item.$lt) && JSON.stringify(item).includes("$dateFromString")) {
          expr.push(item);
        } else {
          and.push(item);
        }
      }
    }

    // Pull top-level fields (like orig_state: "CA")
    for (const [key, value] of Object.entries(query)) {
      if (key !== "$and" && key !== "$expr") {
        and.push({ [key]: value });
      }
    }

    return { and, expr };
  }

  const defaultParts = extractConditions(defaultQuery);
  const assistantParts = extractConditions(assistantQuery);

  finalAnd.push(...defaultParts.and, ...assistantParts.and);
  finalExprAnd.push(...defaultParts.expr, ...assistantParts.expr);

  if (finalAnd.length > 0) {
    combined.$and = finalAnd;
  }

  if (finalExprAnd.length > 0) {
    combined.$expr = { $and: finalExprAnd };
  }

  return combined;
}
export function extractSchemaPropertiesNested(schema) {
  function walk(node) {
    if (!node || typeof node !== "object") return {};

    if (node.properties && typeof node.properties === "object") {
      const result = {};
      for (const key in node.properties) {
        result[key] = walk(node.properties[key]);
      }
      return result;
    }

    return {};
  }

  const result = {};
  for (const key in schema) {
    result[key] = walk(schema[key]);
  }

  return result;
}

var europeanDateFormat = false;
export function getServerURL(objName) {
  // var domain = /:\/\/([^\/]+)/.exec(window.location.href)[1];
  localStorage.setItem("loginTime", new Date());
  return window.location.host.indexOf("moverai.com") == -1 && objName != "aichat"
    ? "http://127.0.0.1:5000"
    : window.location.host.indexOf("emoversoftware") != -1
    ? "https://portal.emoversoftware.com"
    : "https://server.moverai.com";
}
export function setNested(obj, path, value) {
  const keys = path.split(".");
  let target = obj;

  for (let i = 0; i < keys.length - 1; i++) {
    const key = keys[i];

    // If key missing OR key is null → create object
    if (target[key] == null || typeof target[key] !== "object") {
      // Vue reactivity friendly
      target[key] = {};
    }

    target = target[key];
  }

  // Final assignment
  const last = keys[keys.length - 1];
  target[last] = value; // Vue reactivity-safe if in object
}
export function isEmpty(model) {
  return !model || Object.keys(model).length === 0;
}

export function extractLeadDataFromExistingShipment(existingShipment, portal_id = "") {
  var normalizeServiceDate = function(raw) {
    if (!raw) return "";

    const parsed = new Date(raw);
    if (isNaN(parsed.getTime())) return "";

    const m = parsed.getMonth() + 1;
    const d = parsed.getDate();
    const y = parsed.getFullYear();
    const h = parsed.getHours() || 8;
    const min = parsed
      .getMinutes()
      .toString()
      .padStart(2, "0");

    return `${m}/${d}/${y} ${h}:${min}`;
  };
  if (!existingShipment) return null;

  const customer = existingShipment.customer || {};
  const contact = customer.contact || {};

  // Extract pickup & dropoff
  const address = (customer.address || []).map((a, idx) => ({
    full_address: a.full_address || "",
    apt: a.apt || undefined,
    stop_type: idx === 0 ? "pickup" : "dropoff",
    elevator: !!a.elevator,
    flight_of_stairs: typeof a.flight_of_stairs === "number" ? a.flight_of_stairs : undefined
  }));

  // Try to extract service date from estimate if exists
  let service_date = "";
  const svc = existingShipment.estimate["non-binding"].shipment_service?.[0];

  if (svc?.service_date) {
    service_date = normalizeServiceDate(svc.service_date);
  }

  return {
    data: {
      shipment_data: {
        _id: existingShipment._id || "",
        shipment_id: existingShipment.shipment_id,
        contact: {
          _id: customer._id || "",
          full_name: contact.full_name || "",
          first_name: contact.first_name || "",
          last_name: contact.last_name || "",
          email: contact.email || "",

          phones: {
            mobile: {
              phone_number: contact.phones?.mobile?.phone_number || ""
            }
          }
        },

        address,
        inventory: existingShipment.inventory,
        total_estimate: existingShipment.total_estimate,
        booked: svc.booked,
        status: existingShipment.shipment_detail.status,

        service_date,
        comments: existingShipment.shipment_detail?.customer_comments || ""
      },

      calculate: true
    }
  };
}
export function decimalToTime(decimalHours) {
  const hours = Math.floor(decimalHours);
  const minutes = Math.round((decimalHours - hours) * 60);
  return `${hours}:${minutes.toString().padStart(2, "0")}`;
}
export function findRefDeep(name, vm) {
  // 1. Check this component
  if (vm.$refs && vm.$refs[name]) {
    return vm.$refs[name];
  }

  // 2. Recursively search children
  for (let child of vm.$children) {
    const found = this.findRefDeep(name, child);
    if (found) return found;
  }

  return null;
}
export function filePathToUrl(localPath) {
  const baseUrl = "https://portal.moverai.com/";

  // Normalize backslashes → forward slashes
  let p = localPath.replace(/\\/g, "/");

  // Remove C:/inetpub/myportal/ (case-insensitive)
  p = p.replace(/c:\/inetpub\/myportal\//i, "");

  // Return full URL
  return baseUrl + p;
}

export function convertRelativeToAbsolute(html) {
  const baseUrl = window.location.origin; // Automatically get base URL from current site

  return html.replace(/<img\s+[^>]*src=["']([^"']+)["']/gi, (match, src) => {
    // Skip if already an absolute URL
    if (src.startsWith("http") || src.startsWith("https")) {
      return match;
    }

    // Convert to absolute URL
    const absoluteSrc = new URL(src, baseUrl).href;

    return match.replace(src, absoluteSrc);
  });
}

export function isNumericOrObjectId(value) {
  // Check if value is numeric
  const isNumeric = !isNaN(value) && !isNaN(parseFloat(value));

  // Check if value matches the MongoDB ObjectId format
  const objectIdRegex = /^[a-f\d]{24}$/i;
  const isObjectId = objectIdRegex.test(value);

  return isNumeric || isObjectId;
}
export function getSocketURL() {
  return window.location.host.indexOf("localhost") != -1 ? "http://localhost:3030" : "https://server.moverai.com:5000";
}
export function interpolate(template, data) {
  return template.replace(/\{\{([^}]+)\}\}/g, (match, p1) => {
    const path = p1.trim().split(".");
    let currentValue = data;
    for (let i = 0; i < path.length; i++) {
      currentValue = currentValue[path[i]];
      if (currentValue === undefined) {
        return "";
      }
    }
    return currentValue;
  });
}
export function getRule(r, label) {
  try {
    var rules = {
      arrayRules: [
        v => {
          if (!v || v.length < 1) return label + " is required";
          else return true;
        }
      ],

      nameRules: [v => !!v || label + " is required"],
      emailRules: [v => !!v || label + " is required", v => /.+@.+\..+/.test(v) || label + " must be valid"],
      editorRules: [v => /^{{\s*(\w+\.?)+\s*}}$/gm.test(v) || label + " invalid"],
      passwordRules: [
        v => !!v || "Password is required",
        v => (v && v.length >= 6) || "Password must be at least 6 characters" // You can add additional rules as needed
      ]
    };

    return rules[r];
  } catch (error) {
    return false;
  }
}
export function innerJoin(arr1, arr2, key1, key2) {
  return arr1
    .map(item1 => {
      // Find the matching object in arr2 based on key1 and key2
      const matchingItem = arr2.find(item2 => item1[key1] === item2[key2]);

      // Return the merged object if a match is found, otherwise null
      return matchingItem ? { ...item1, ...matchingItem } : null;
    })
    .filter(item => item !== null); // Filter out null values (no matches)
}

export function splitByLastCharacter(str, char) {
  // Find the last occurrence of the character
  const lastIndex = str.lastIndexOf(char);
  // If the character is not found, return the original string and an empty string
  if (lastIndex === -1) {
    return [str, ""];
  }
  // Split the string into two parts based on the last occurrence of the character
  const part1 = str.substring(0, lastIndex);
  const part2 = str.substring(lastIndex + 1); // +1 to exclude the character itself from the second part
  return [part1, part2];
}
export function reverseDeductionPercentage(n) {
  const deductedFactor = 1 - n / 100;
  const percentageIncrease = (1 / deductedFactor - 1) * 100;
  return percentageIncrease;
}
export function checkParentClass(element, className) {
  while (element) {
    if (element.classList && element.classList.contains(className)) {
      return true;
    }
    element = element.parentElement;
  }

  return false;
}
export function getObjectSize(obj) {
  // Base case: If the object is not an object or is null, return 0
  if (obj === null || typeof obj !== "object") {
    return 0;
  }

  let size = 0;

  // Iterate over each property in the object
  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      const value = obj[key];
      // Add the size of the key (converted to a string)
      size += new TextEncoder().encode(key).length;
      // Add the size of the value (if it's an object, recursively call the function)
      size += getObjectSize(value);
    }
  }

  return size;
}
export function compareObjects(obj1, obj2) {
  if (typeof obj1 !== "object" || typeof obj2 !== "object" || obj1 === null || obj2 === null) {
    return obj1 === obj2;
  }

  const keys1 = Object.keys(obj1);
  const keys2 = Object.keys(obj2);

  if (keys1.length !== keys2.length) return false;

  for (let key of keys1) {
    if (!keys2.includes(key) || !compareObjects(obj1[key], obj2[key])) {
      return false;
    }
  }

  return true;
}

export function compareDates(date1, date2) {
  if (
    new Date(date1).getUTCDate() === new Date(date2).getUTCDate() &&
    new Date(date1).getUTCMonth() === new Date(date2).getUTCMonth() &&
    new Date(date1).getUTCFullYear() === new Date(date2).getUTCFullYear()
  ) {
    return true;
  }
}
export function delay(seconds) {
  const milliseconds = seconds * 1000;
  const startTime = Date.now();

  while (Date.now() - startTime < milliseconds) {
    // Wait until the desired time has passed
  }
  return true;
}
export function jsonToCsv(jsonData) {
  // Map the JSON data to an array of arrays
  var data = jsonData.map(Object.values);

  // Get the header from the keys of the first object
  var header = Object.keys(jsonData[0]);

  // Join each array of values into a string, separated by commas
  data = data.map(row => row.join(","));

  // Join the header and the data, separated by newlines
  var csv = [header.join(",")].concat(data).join("\n");

  return csv;
}
export function isDev() {
  return window.location.host.indexOf("localhost") != -1;
}
export function encrypt(msg, passPhrase) {
  return window.CryptoJS.AES.encrypt(msg, passPhrase).toString();
}
export function decrypt(msg, passPhrase) {
  return window.CryptoJS.AES.decrypt(msg, passPhrase).toString(window.CryptoJS.enc.Utf8);
}
export function findParentByTagName(element, tagName) {
  tagName = tagName.toUpperCase(); // Ensure the tag name is in uppercase, as element.tagName is always uppercase
  while (element && element.parentNode) {
    element = element.parentNode;
    if (element.tagName === tagName) {
      return element;
    }
  }
  return null; // Return null if no parent with the specified tag name is found
}
export function formatCurrency(value, currency, locale = "en-US") {
  // const formatter = new Intl.NumberFormat(currency.value, {
  //   style: 'currency',
  //   currency: currency.name,
  //   // Optional settings below:
  //   // minimumFractionDigits: 2, // (this is the default when currency is used)
  //   // maximumFractionDigits: 2,

  // });

  try {
    return new Intl.NumberFormat(locale, {
      style: "currency",
      currency: currency
    }).format(value);
  } catch (error) {
    console.log(error);
    return value;
  }
}
export function getParentByProperty(obj, property) {
  var val = undefined;
  if (obj) {
    // var keys = Object.keys(obj);
    // keys.forEach(function(key) {
    //   if (key == property) {
    //     val = obj[property];
    //   }
    // });
    // if (val != undefined) {
    if (obj[property] != undefined) {
      return obj;
    } else {
      return getParentByProperty(obj.$parent, property);
    }
  }
}
export function queryStringToJSON(qs) {
  qs = qs || location.search.slice(1);

  var pairs = qs.split("&");
  var result = {};
  pairs.forEach(function(p) {
    var pair = p.split("=");
    var key = pair[0];
    var value = decodeURIComponent(pair[1] || "");

    if (result[key]) {
      if (Object.prototype.toString.call(result[key]) === "[object Array]") {
        result[key].push(value);
      } else {
        result[key] = [result[key], value];
      }
    } else {
      result[key] = value;
    }
  });

  return JSON.parse(JSON.stringify(result));
}
export function isHoliday(date) {
  // Hardcoded public holidays
  let holidays = [
    // New Year's Day
    new Date(date.getFullYear(), 0, 1),
    // Independence Day
    new Date(date.getFullYear(), 6, 4),
    // Christmas
    new Date(date.getFullYear(), 11, 25)
  ];

  // Add holidays that fall on a specific weekday in a month
  // Memorial Day (last Monday in May)
  holidays.push(new Date(date.getFullYear(), 4, 31));
  while (holidays[holidays.length - 1].getDay() !== 1) {
    holidays[holidays.length - 1].setDate(holidays[holidays.length - 1].getDate() - 1);
  }

  // Labor Day (first Monday in September)
  holidays.push(new Date(date.getFullYear(), 8, 1));
  while (holidays[holidays.length - 1].getDay() !== 1) {
    holidays[holidays.length - 1].setDate(holidays[holidays.length - 1].getDate() + 1);
  }

  // Thanksgiving (fourth Thursday in November)
  holidays.push(new Date(date.getFullYear(), 10, 1));
  let thursdays = 0;
  while (thursdays < 4) {
    if (holidays[holidays.length - 1].getDay() === 4) {
      thursdays++;
    }
    holidays[holidays.length - 1].setDate(holidays[holidays.length - 1].getDate() + 1);
  }

  // Check if date is a holiday
  return holidays.some(
    holiday =>
      holiday.getDate() === date.getDate() &&
      holiday.getMonth() === date.getMonth() &&
      holiday.getFullYear() === date.getFullYear()
  );
}

export function addBusinessDays(date, days) {
  let count = 0;
  while (count < days) {
    date.setDate(date.getDate() + 1);
    // Skip weekends and holidays
    if (date.getDay() !== 0 && date.getDay() !== 6 && !isHoliday(date)) {
      count++;
    }
  }
  return date;
}
// export function AddBusinessDays(firstDate, weekDaysToAdd) {
//   var natDays = [
//     [7, 4, 'us'], [1, 1, 'us'], [12, 25, 'us'], [11, 11, 'us']
//   ];

//   var addHolidays = function (year) {

//     var myDate = new Date();
//     myDate.setHours(0, 0, 0, 0);

//     // Set ThanksGiving
//     myDate.setYear(year);
//     myDate.setDate(1);
//     myDate.setMonth(10);

//     // Find Thursday.
//     var thursday = 4;
//     while (myDate.getDay() != thursday) {
//       myDate.setDate(myDate.getDate() + 1);
//     }

//     // Add 3 weeks.
//     var tDay = myDate.getDate() + 21;
//     natDays.push([11, tDay, 'us']);

//     // Set President Day

//     myDate.setYear(year);
//     myDate.setDate(1);
//     myDate.setMonth(1);

//     var monday = 1;

//     while (myDate.getDay() != monday) {
//       myDate.setDate(myDate.getDate() + 1);
//     }
//     var pDay = myDate.getDate() + 14;
//     natDays.push([2, pDay, 'us']);

//     // Set Labor Day

//     myDate.setYear(year);
//     myDate.setDate(1);
//     myDate.setMonth(8);

//     while (myDate.getDay() != monday) {
//       myDate.setDate(myDate.getDate() + 1);
//     }
//     pDay = myDate.getDate()// + 14;
//     natDays.push([9, pDay, 'us']);

//     // Set Columbus Day

//     myDate.setYear(year);
//     myDate.setDate(1);
//     myDate.setMonth(9);

//     while (myDate.getDay() != monday) {
//       myDate.setDate(myDate.getDate() + 1);
//     }
//     pDay = myDate.getDate() + 7;
//     natDays.push([10, pDay, 'us']);

//     // Set Martin Luter King Day
//     myDate.setYear(year);
//     myDate.setDate(1);
//     myDate.setMonth(0);

//     while (myDate.getDay() != monday) {
//       myDate.setDate(myDate.getDate() + 1);
//     }
//     pDay = myDate.getDate() + 14;
//     natDays.push([1, pDay, 'us']);

//     // Set Memorial Day
//     myDate.setYear(year);
//     myDate.setDate(31);
//     myDate.setMonth(4);

//     myDate.setDate(myDate.getDate() - 1);
//     while (myDate.getDay() != monday) {
//       myDate.setDate(myDate.getDate() - 1);
//     }
//     pDay = myDate.getDate()// + 21;
//     natDays.push([5, pDay, 'us']);

//     // Set July 3 if July 4 falls on weekend
//     myDate.setYear(year);
//     myDate.setDate(3);
//     myDate.setMonth(6);

//     var friday = 5;
//     if (myDate.getDay() == friday)
//     //    while (myDate.getDay() != friday) {
//     //        myDate.setDate(myDate.getDate() + 1);
//     //    }
//     {
//       pDay = myDate.getDate();
//       natDays.push([7, pDay, 'us']);

//     }

//   }
//   addHolidays(firstDate.getYear());
//   var curdate = firstDate;
//   var realDaysToAdd = 0;
//   while (weekDaysToAdd > 0) {
//     curdate.setDate(curdate.getDate() + 1);
//     realDaysToAdd++;
//     //check if current day is business day
//     // if (noWeekendsOrHolidays(curdate)[0]) {
//     //   weekDaysToAdd--;
//     // }
//   }
//   return realDaysToAdd;

// }

export function getParentsByProperty(obj, property) {
  var objects = [];
  var val = undefined;
  if (obj) {
    var keys = Object.keys(obj);
    keys.forEach(function(key) {
      if (key == property) {
        val = obj[property];
      }
    });
    if (val != undefined) {
      objects.push(obj);
    } else {
      return getParentsByProperty(obj.$parent, property);
    }
  }
  return objects;
}
// export function getFullPath(obj, property) {
//   var objects = [];
//   var val = undefined;
//   var findKey = function() {
//     if (obj) {
//       var keys = Object.keys(obj);

//       keys.forEach(function(key) {
//         if (typeof obj == "object") {

//         } else {
//           if (key == property) {
//             objects.push(key);
//           }
//         }
//       });

//     }
//   };

//   return objects;
// }
export function getParentByPropertyValue(obj, property, value) {
  var val = undefined;
  if (obj) {
    var keys = Object.keys(obj);
    keys.forEach(function(key) {
      if (key == property) {
        val = obj[property];
      }
    });
    if (val == value) {
      return obj;
    } else {
      return getParentByPropertyValue(obj.$parent, property, value);
    }
  }
}

export function getChildByRef(obj, ref) {
  var child = null;
  if (obj.$refs) {
    if (obj.$refs[ref]) {
      child = obj.$refs[ref];
    } else {
      var children = obj.$children;
      children.forEach(c => {
        var myChild = getChildByRef(c, ref);
        if (myChild) {
          child = myChild;
        }
      });
    }
  }
  return child;
}

export function getChildByModelId(obj, id) {
  var child = null;
  if (obj.model) {
    if (obj.model._id == id) {
      child = obj;
    } else {
      var children = obj.$children;
      children.forEach(c => {
        var myChild = getChildByModelId(c, id);
        if (myChild) {
          child = myChild;
        }
      });
    }
  }
  return child;
}

export function findObjectsByPropValue(obj, targetProp, targetValue) {
  const results = [];

  function traverse(currentObject, currentPath) {
    if (Array.isArray(currentObject)) {
      // Iterate over array elements
      currentObject.forEach((item, index) => {
        traverse(item, currentPath + `[${index}]`);
      });
    } else if (currentObject !== null && typeof currentObject === "object") {
      // Check if the current object contains the target property with the target value
      if (currentObject.hasOwnProperty(targetProp) && currentObject[targetProp] === targetValue) {
        results.push({ path: currentPath, obj: currentObject });
      }
      // Recurse into the object to find deeper matches
      Object.keys(currentObject).forEach(key => {
        traverse(currentObject[key], currentPath + (currentPath ? "." : "") + key);
      });
    }
  }

  traverse(obj, ""); // Start traversal with an empty path
  return results;
}

export function getObjects(obj, key, val) {
  var objects = [];
  for (var i in obj) {
    if (!obj.hasOwnProperty(i)) continue;
    if (typeof obj[i] == "object") {
      if (typeof val == "object" && obj[key] == val) {
        objects.push(obj);
      } else {
        try {
          objects = objects.concat(getObjects(obj[i], key, val));
        } catch (e) {
          // console.log(e);
        }
      }
    } else if (i == key && obj[key].toString().toLowerCase() == val.toString().toLowerCase()) {
      objects.push(obj);
    }
  }
  return objects;
}
export function getObjectsKeysAndPath(obj, key, val, parObj) {
  var objects = [];
  for (var i in obj) {
    if (!obj.hasOwnProperty(i)) continue;
    if (typeof obj[i] == "object") {
      try {
        objects = objects.concat(getObjectsKeysAndPath(obj[i], key, val, obj));
      } catch (e) {
        console.log(e);
      }
    } else if (i == key && obj[key].toString().toLowerCase() == val.toString().toLowerCase()) {
      objects.push(getObjectKey(obj, parObj));
    }
  }
  return objects;
}

export function getObjectsKeys(obj, key, val, parObj) {
  var objects = [];
  for (var i in obj) {
    if (!obj.hasOwnProperty(i)) continue;
    if (typeof obj[i] == "object") {
      try {
        objects = objects.concat(getObjectsKeys(obj[i], key, val, obj));
      } catch (e) {
        console.log(e);
      }
    } else if (i == key && obj[key].toString().toLowerCase() == val.toString().toLowerCase()) {
      objects.push(getObjectKey(obj, parObj));
    }
  }
  return objects;
}

// var keys=[];
export function findPath(ob, key, value) {
  const path = [];
  const keyExists = obj => {
    if (!obj || (typeof obj !== "object" && !Array.isArray(obj))) {
      return false;
    } else if (obj.hasOwnProperty(key) && obj[key] === value) {
      return true;
    } else if (Array.isArray(obj)) {
      let parentKey = path.length ? path.pop() : "";

      for (let i = 0; i < obj.length; i++) {
        path.push(`${parentKey}[${i}]`);
        const result = keyExists(obj[i], key);
        if (result) {
          return result;
        }
        path.pop();
      }
    } else {
      for (const k in obj) {
        path.push(k);
        const result = keyExists(obj[k], key);
        if (result) {
          return result;
        }
        path.pop();
      }
    }

    return false;
  };

  keyExists(ob);

  return path.join(".");
}

export function getObjectKeyProperty(obj, parObj, key) {
  if (parObj.properties) {
    var prop = parObj.properties;
    Object.keys(prop).forEach(k => {
      // if (typeof parObj.properties[k] === "object") {
      if (prop[k] == obj) {
        key = k;
      } else if (prop[k] && prop[k].properties) {
        key = getObjectKeyProperty(obj, prop[k], key);
      }
      // }
    });
  }

  return key;
}
export function getObjectByPath(obj, path) {
  path.forEach(k => {
    if (obj) {
      obj = obj[k];
    }
  });
  return obj;
}
export function getObjectKey(obj, parObj, key) {
  Object.keys(parObj).forEach(k => {
    // if (typeof parObj.properties[k] === "object") {
    if (parObj[k] == obj) {
      key = k;
    }
    // }
  });

  return key;
}
export function getOffset(el) {
  var _x = 0;
  var _y = 0;
  while (el && !isNaN(el.offsetLeft) && !isNaN(el.offsetTop)) {
    _x += el.offsetLeft - el.scrollLeft;
    _y += el.offsetTop - el.scrollTop;
    el = el.offsetParent;
  }
  return { top: _y, left: _x };
}
export function getObjectByKey(obj, key) {
  var o = null;
  Object.keys(obj).forEach(function(k) {
    if (k == key) {
      o = obj[k];
    }
    if (!o) {
      if (obj[k] && typeof obj[k] == "object" && !Array.isArray(obj[k])) {
        o = getObjectByKey(obj[k], key);
      }
    }
  });

  return o;
}

export function getNumber(n) {
  return !isNaN(parseFloat(n)) ? n : 0;
}
export function extractNumericString(inputString, removeFirst1) {
  // Use a regular expression to match all digits
  var numericString = inputString.replace(/\D/g, "");
  if (removeFirst1) {
    if (numericString.startsWith("1")) {
      // Remove the first character ('1') using substring
      numericString = numericString.substring(1);
    }
  }

  return numericString;
}
export function getInputSelection(elem, text) {
  if (typeof elem != "undefined") {
    var s = elem.selectionStart;
    var e = elem.selectionEnd;
    return { s: s, e: e };
  } else {
    return "";
  }
}
export function getObjectsByKey(obj, key) {
  var objects = [];
  if (obj[key]) {
    objects.push(obj[key]);
  }

  for (var i in obj) {
    if (!obj.hasOwnProperty(i)) continue;
    if (typeof obj[i] == "object") {
      try {
        objects = objects.concat(getObjectsByKey(obj[i], key));
      } catch (e) {
        // console.log(e);
      }
    } else if (i == key && obj[key]) {
      objects.push(obj[key]);
    }
  }

  return objects;
}

export function containsObject(obj, list) {
  var contains = list.length;
  list.forEach(el => {
    Object.keys(el).forEach(k => {
      if (obj[k] != el[k]) {
        contains = false;
      }
    });
  });
  return contains;
  // var i;
  // for (i = 0; i < list.length; i++) {
  //     if (list[i] === obj) {
  //         return true;
  //     }
  // }

  // return false;
}

export function predicateBy(prop) {
  return function(a, b) {
    if (a[prop] > b[prop]) {
      return 1;
    } else if (a[prop] < b[prop]) {
      return -1;
    }
    return 0;
  };
}

export function nope() {
  var result = "";
  var characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  var charactersLength = characters.length;
  for (var i = 0; i < charactersLength; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}
export function deepDiffMapper() {
  return {
    VALUE_CREATED: "created",
    VALUE_UPDATED: "updated",
    VALUE_DELETED: "deleted",
    VALUE_UNCHANGED: "unchanged",
    map: function(obj1, obj2) {
      if (this.isFunction(obj1) || this.isFunction(obj2)) {
        throw "Invalid argument. Function given, object expected.";
      }
      if (this.isValue(obj1) || this.isValue(obj2)) {
        return {
          type: this.compareValues(obj1, obj2),
          data: obj1 === undefined ? obj2 : obj1
        };
      }

      var diff = {};
      for (var key in obj1) {
        if (this.isFunction(obj1[key])) {
          continue;
        }

        var value2 = undefined;
        if (obj2[key] !== undefined) {
          value2 = obj2[key];
        }

        diff[key] = this.map(obj1[key], value2);
      }
      for (var key2 in obj2) {
        if (this.isFunction(obj2[key2]) || diff[key2] !== undefined) {
          continue;
        }

        diff[key2] = this.map(undefined, obj2[key2]);
      }

      return diff;
    },
    compareValues: function(value1, value2) {
      if (value1 === value2) {
        return this.VALUE_UNCHANGED;
      }
      if (this.isDate(value1) && this.isDate(value2) && value1.getTime() === value2.getTime()) {
        return this.VALUE_UNCHANGED;
      }
      if (value1 === undefined) {
        return this.VALUE_CREATED;
      }
      if (value2 === undefined) {
        return this.VALUE_DELETED;
      }
      return this.VALUE_UPDATED;
    },
    isFunction: function(x) {
      return Object.prototype.toString.call(x) === "[object Function]";
    },
    isArray: function(x) {
      return Object.prototype.toString.call(x) === "[object Array]";
    },
    isDate: function(x) {
      return Object.prototype.toString.call(x) === "[object Date]";
    },
    isObject: function(x) {
      return Object.prototype.toString.call(x) === "[object Object]";
    },
    isValue: function(x) {
      return !this.isObject(x) && !this.isArray(x);
    }
  };
}
export function newline(msg, test_value) {
  if (!test_value) {
    test_value = document.getElementById("test").value;
  }
  return msg + ": " + (test_value.match(/\r/) ? "CR" : "") + " " + (test_value.match(/\n/) ? "LF" : "");
}
export function compare(a, b, property) {
  var getText = function(item) {
    var path = property.split(".");
    var v = item;
    path.forEach(p => {
      v = v[p];
    });
    return v;
  };
  if (getText(a) && getText(b) && isNaN(getText(a)) && isNaN(getText(b))) {
    if (
      getText(a)
        .toString()
        .toLowerCase() <
      getText(b)
        .toString()
        .toLowerCase()
    ) {
      return -1;
    }
    if (
      getText(a)
        .toString()
        .toLowerCase() >
      getText(b)
        .toString()
        .toLowerCase()
    ) {
      return 1;
    }
  } else {
    if (getText(a) < getText(b)) {
      return -1;
    }
    if (getText(a) > getText(b)) {
      return 1;
    }
  }

  return 0;
}
export function roughSizeOfObject(object) {
  var objectList = [];
  var stack = [object];
  var bytes = 0;

  while (stack.length) {
    var value = stack.pop();

    if (typeof value === "boolean") {
      bytes += 4;
    } else if (typeof value === "string") {
      bytes += value.length * 2;
    } else if (typeof value === "number") {
      bytes += 8;
    } else if (typeof value === "object" && objectList.indexOf(value) === -1) {
      objectList.push(value);

      for (var i in value) {
        stack.push(value[i]);
      }
    }
  }
  return ((bytes * 2) / 1024).toFixed(0) + " kb";
}
export function getMaxFieldValue(array, field) {
  if (array.length === 0) {
    return null; // Return null if the array is empty
  }

  var maxField = array[0][field]; // Assume the first element has the maximum field value

  for (var i = 1; i < array.length; i++) {
    var currentField = array[i][field];
    if (currentField > maxField) {
      maxField = currentField;
    }
  }

  return maxField;
}
export function sortArrayOfObjectsByProperties(arr, properties) {
  arr.sort(function(a, b) {
    for (var i = 0; i < properties.length; i++) {
      var property = properties[i];
      var aValue = a[property];
      var bValue = b[property];

      if (aValue < bValue) {
        return -1;
      } else if (aValue > bValue) {
        return 1;
      }
    }
    return 0;
  });
}
export function removeLeadingZeros(dateString) {
  return dateString.replace(/\b0(\d)/g, "$1");
}

export function convertToEuropean(dateString) {
  let parsedDate;

  // Try to parse ISO-like format (e.g., 2025-01-31 07:00)
  if (/^\d{4}-\d{2}-\d{2}( \d{2}:\d{2}(:\d{2})?)?$/.test(dateString)) {
    const [datePart, timePart] = dateString.split(" ");
    const [year, month, day] = datePart.split("-").map(Number);
    parsedDate = new Date(year, month - 1, day, ...(timePart ? timePart.split(":").map(Number) : []));
  }
  // Try to parse US format (e.g., MM/DD/YYYY or MM/DD/YYYY HH:mm)
  else if (/^\d{1,2}\/\d{1,2}\/\d{4}( \d{1,2}:\d{2}(:\d{2})?)?$/.test(dateString)) {
    const [datePart, timePart] = dateString.split(" ");
    const [month, day, year] = datePart.split("/").map(Number);
    parsedDate = new Date(year, month - 1, day, ...(timePart ? timePart.split(":").map(Number) : []));
  }
  // Try to parse European format (e.g., DD/MM/YYYY or DD/MM/YYYY HH:mm)
  else if (/^\d{1,2}\/\d{1,2}\/\d{4}( \d{1,2}:\d{2}(:\d{2})?)?$/.test(dateString)) {
    const [datePart, timePart] = dateString.split(" ");
    const [day, month, year] = datePart.split("/").map(Number);
    parsedDate = new Date(year, month - 1, day, ...(timePart ? timePart.split(":").map(Number) : []));
  }

  // Return empty string if parsing fails
  if (!parsedDate || isNaN(parsedDate.getTime())) {
    return "";
  }

  // Format the parsed date into DD/MM/YYYY or DD/MM/YYYY HH:mm:ss
  const pad = num => String(num).padStart(2, "0");
  const day = pad(parsedDate.getDate());
  const month = pad(parsedDate.getMonth() + 1);
  const year = parsedDate.getFullYear();
  const hours = pad(parsedDate.getHours());
  const minutes = pad(parsedDate.getMinutes());
  const seconds = pad(parsedDate.getSeconds());

  // Check if the input included time
  const hasTime = dateString.includes(":");
  return hasTime ? `${day}/${month}/${year} ${hours}:${minutes}:${seconds}` : `${day}/${month}/${year}`;
}

export function convertToEuropean_(dateString) {
  if (!dateString || dateString == "None") {
    return "";
  }

  // Parse the US format
  const [datePart, timePart] = dateString.split(" ");
  const [month, day, year] = datePart.split("/");
  return `${day}/${month}/${year}${timePart ? " " + timePart : ""}`; // European format
}
export function convertToUS(dateString) {
  let parsedDate;

  // Check for ISO format or standard Date.parse compatibility
  if (!isNaN(Date.parse(dateString))) {
    parsedDate = new Date(dateString);
  } else if (/^\d{1,2}\/\d{1,2}\/\d{4}/.test(dateString)) {
    // Check if the format is EU (DD/MM/YYYY or DD/MM/YYYY HH:mm)
    const [datePart, timePart = "00:00"] = dateString.split(" ");
    const [day, month, year] = datePart.split("/").map(Number);
    const [hour, minute = 0] = timePart.split(":").map(Number);

    parsedDate = new Date(year, month - 1, day, hour, minute);
  } else {
    throw new Error("Invalid date format");
  }

  // Format the parsed date into US format
  const pad = num => String(num).padStart(2, "0");
  const month = pad(parsedDate.getMonth() + 1);
  const day = pad(parsedDate.getDate());
  const year = parsedDate.getFullYear();
  const hours = pad(parsedDate.getHours());
  const minutes = pad(parsedDate.getMinutes());
  const seconds = pad(parsedDate.getSeconds());

  // Return US format with time
  return `${month}/${day}/${year} ${hours}:${minutes}:${seconds}`;
}
export function convertDateFormat(dateStr) {
  europeanDateFormat = JSON.parse(localStorage["portal_settings"])[0]["european_date_format"];
  if (!europeanDateFormat) {
    return dateStr;
  }
  return convertToEuropean(dateStr);
}
export function convertDateFormat_(dateStr) {
  // Split the input into date and time parts
  const [datePart, timePart] = dateStr.split(" ");

  let date;

  if (datePart.includes("/")) {
    // Input is in US format (MM/DD/YYYY)
    const [month, day, year] = datePart.split("/").map(Number);
    date = new Date(year, month - 1, day); // Create a Date object
  } else if (datePart.includes("-")) {
    // Input is in ISO format (YYYY-MM-DD)
    const [year, month, day] = datePart.split("-").map(Number);
    date = new Date(year, month - 1, day); // Create a Date object
  } else {
    throw new Error(`Invalid date format: ${dateStr}`);
  }

  // Handle time conversion if timePart is present
  let formattedTime = "";
  if (timePart) {
    const [hour, minute] = timePart.split(":").map(Number);
    try {
      europeanDateFormat = JSON.parse(localStorage["portal_settings"])[0]["european_date_format"];
    } catch (error) {
      //
    }
    if (europeanDateFormat) {
      // Convert to 24-hour format if not already
      const hour24 = hour % 24; // Ensure the hour is within 0-23 range
      formattedTime = `${String(hour24).padStart(2, "0")}:${String(minute).padStart(2, "0")}`;
    } else {
      // Convert to 12-hour format with AM/PM
      const hour12 = hour % 12 || 12; // Adjust 0-hour to 12
      const period = hour >= 12 ? "PM" : "AM";
      formattedTime = `${hour12}:${String(minute).padStart(2, "0")} ${period}`;
    }
  }

  // Format the date based on the global constant
  try {
    europeanDateFormat = JSON.parse(localStorage["portal_settings"])[0]["european_date_format"];
  } catch (error) {
    //
  }
  if (europeanDateFormat) {
    // Convert to European format (DD/MM/YYYY)
    const day = String(date.getUTCDate()).padStart(2, "0");
    const month = String(date.getUTCMonth() + 1).padStart(2, "0"); // Months are 0-based
    const year = date.getUTCFullYear();
    return `${day}/${month}/${year}${formattedTime ? ` ${formattedTime}` : ""}`;
  } else {
    // Convert to US format (MM/DD/YYYY)
    const month = String(date.getUTCMonth() + 1).padStart(2, "0"); // Months are 0-based
    const day = String(date.getUTCDate()).padStart(2, "0");
    const year = date.getUTCFullYear();
    return `${month}/${day}/${year}${formattedTime ? ` ${formattedTime}` : ""}`;
  }
}
export function sortObjectByKey(object, sortingKey) {
  // Convert the object into an array of key-value pairs
  const keyValueArray = Object.entries(object);

  // Sort the array based on the specified sorting key within each child object
  keyValueArray.sort((a, b) => {
    const valueA = a[1][sortingKey].toLowerCase();
    const valueB = b[1][sortingKey].toLowerCase();

    return valueA.localeCompare(valueB);
  });

  // Convert the sorted array back into an object
  const sortedObject = Object.fromEntries(keyValueArray);

  return sortedObject;
}
export function extractCityState(address) {
  // Split the address by comma
  const parts = address.split(",");

  // Assuming the city is always the second to last element after splitting
  // and the state + zip (or state + zip + country) is the last element.
  const city = parts[parts.length - 3].trim();
  const stateZipCountry = parts[parts.length - 2].trim();

  // Further split the stateZipCountry part by spaces to isolate the state
  const state = stateZipCountry.split(" ")[0];

  return { city, state };
}
export function findDuplicates(dataArray, key) {
  if (!key) {
    key = "_id";
  }
  const seen = {};
  const duplicates = dataArray.filter(item => {
    if (Object.prototype.hasOwnProperty.call(seen, item[key])) {
      return true;
    }
    seen[item[key]] = true;
    return false;
  });
  return duplicates;
}
export function sendMessageToIframe(id, type, message) {
  const iframe = document.getElementById(id);
  console.log("iframe", iframe);
  console.log("message", message);
  if (iframe) {
    iframe.contentWindow.postMessage(
      {
        type: type,
        payload: { message: message }
      },
      window.location.origin
    );
  }
}

export function getUnique(dataArray, key) {
  if (!key) {
    key = "_id";
  }
  const seen = {};

  const uniqueArray = dataArray.filter(item => {
    return Object.prototype.hasOwnProperty.call(seen, item[key]) ? false : (seen[item[key]] = true);
  });
  return uniqueArray;
}
// export function mergeArrays(arr1, arr2, key) {
//   const mergedMap = new Map();

//   [...arr1, ...arr2].forEach(item => {
//     mergedMap.set(item[key], item); // Use the dynamic key for uniqueness
//   });

//   return Array.from(mergedMap.values());
// }
export function sortObjects(objs, property, desc, options = {}) {
  if (!property) return;

  const { nonAlphanumericLast = false } = options;
  const prop = Array.isArray(property) ? property[0] : property;

  objs.sort((a, b) => {
    let valA = a?.[prop] ?? "";
    let valB = b?.[prop] ?? "";

    // ---- Non-alphanumeric last ----
    if (nonAlphanumericLast) {
      const aNonAlpha = !/^[a-z0-9]/i.test(String(valA));
      const bNonAlpha = !/^[a-z0-9]/i.test(String(valB));

      if (aNonAlpha && !bNonAlpha) return 1;
      if (!aNonAlpha && bNonAlpha) return -1;
    }

    // ---- Date handling ----
    if (prop?.includes("_date") || prop?.includes("date_")) {
      valA = formatDate(valA, true, true);
      valB = formatDate(valB, true, true);
    }

    valA = String(valA);
    valB = String(valB);

    // ---- Natural sort (numeric inside text) ----
    const result = valA.localeCompare(valB, undefined, {
      numeric: true,
      sensitivity: "base"
    });

    return desc ? -result : result;
  });
}

export function dynamicSort(property, sortOrder) {
  if (!sortOrder) {
    sortOrder = 1;
  } else {
    sortOrder = -1;
  }
  // if (property[0] === "-") {
  //   sortOrder = -1;
  //   property = property.substr(1);
  // }
  return function(a, b) {
    /* next line works with strings and numbers,
     * and you may want to customize it to your needs
     */
    var result =
      a[property].toLowerCase() < b[property].toLowerCase()
        ? -1
        : a[property].toLowerCase() > b[property].toLowerCase()
        ? 1
        : 0;
    return result * sortOrder;
  };
}
export function getArrayElementById(r, id) {
  var index = r
    .map(function(el) {
      return el._id;
    })
    .indexOf(id);

  return r[index];
}
export function getArrayElementIndexById(r, id) {
  var index = r
    .map(function(el) {
      return el._id;
    })
    .indexOf(id);

  return index;
}
export function mergeMissing(target, source) {
  if (!source || typeof source !== "object") return target;

  Object.keys(source).forEach(key => {
    const srcVal = source[key];
    const tgtVal = target[key];

    // ✅ undefined OR null → treat as missing
    if (tgtVal === undefined || tgtVal === null) {
      target[key] = srcVal;
      return;
    }

    // recurse only for plain objects
    if (
      typeof tgtVal === "object" &&
      typeof srcVal === "object" &&
      tgtVal !== null &&
      srcVal !== null &&
      !Array.isArray(tgtVal) &&
      !Array.isArray(srcVal)
    ) {
      mergeMissing(tgtVal, srcVal);
    }
  });

  return target;
}

export function mergeObjects(obj1, obj2) {
  const merged = {};

  // Iterate over the keys of both objects
  for (const key of new Set([...Object.keys(obj1), ...Object.keys(obj2)])) {
    const value1 = obj1[key];
    const value2 = obj2[key];

    if (Array.isArray(value1) && Array.isArray(value2)) {
      // Combine arrays
      merged[key] = [...value1, ...value2];
    } else if (typeof value1 === "object" && typeof value2 === "object") {
      // Recursively merge objects
      merged[key] = mergeObjects(value1, value2);
    } else if (typeof value1 === "number" && typeof value2 === "number") {
      // Sum numbers
      merged[key] = value1 + value2;
    } else if (typeof value1 === "string" && typeof value2 === "string") {
      // Concatenate strings
      merged[key] = value1 + value2;
    } else {
      // If one value is undefined, take the other one
      merged[key] = value2 !== undefined ? value2 : value1;
    }
  }

  return merged;
}
export function mergeObjectsWithOverride(obj1, obj2) {
  const result = { ...obj1 };

  for (const key in obj2) {
    if (obj2[key] && typeof obj2[key] === "object" && !Array.isArray(obj2[key]) && typeof obj1[key] === "object") {
      result[key] = mergeObjects(obj1[key], obj2[key]);
    } else {
      result[key] = obj2[key];
    }
  }

  return result;
}

export function mergeArrays(arr1 = [], arr2 = [], key = "_id") {
  arr1.forEach(a1 => {
    if (
      arr2.filter(f => {
        return f[key] == a1[key];
      }).length
    ) {
      arr2.forEach(a2 => {
        if (a2[key] == a1[key]) {
          a2 = a1;
        }
      });
    } else {
      arr2.push(a1);
    }
  });
  return arr2;
}

// export function createClass(className, classCss) {
//   try {
//     var style = document.getElementById("style_main");
//     var cl = ";\n." + className + " { " + classCss + "}";
//     // style.type = "text/css";
//     if (style.innerHTML.indexOf(cl) == -1) {
//       style.innerHTML += cl;
//       // return className + " created";
//     }
//     // return className + " already exists";
//   } catch (error) {
//     console.log(error);
//     // return error;
//   }

//   // document.getElementsByTagName("head")[0].appendChild(style);
// }
export function uniqueArray(arr) {
  const seen = new Set();
  return arr.filter(item => {
    const serialized = JSON.stringify(item);
    if (seen.has(serialized)) {
      return false;
    }
    seen.add(serialized);
    return true;
  });
}
export function uniqueByProperty(arr, key) {
  const seen = new Set();
  return arr.filter(item => {
    if (seen.has(item[key])) {
      return false;
    }
    seen.add(item[key]);
    return true;
  });
}
export function htmlToText(html) {
  var temp = document.createElement("div");
  temp.innerHTML = html;
  return temp.textContent || temp.innerText || "";
}
export function clone(oldObj) {
  if (oldObj) {
    var oldObjStr = JSON.stringify(oldObj);
    return JSON.parse(oldObjStr);
  }
}

var path = [];

export function resetPath() {
  path = [];
}
export function ignoreTimeZone(d) {
  var date = new Date(d);
  var userTimezoneOffset = date.getTimezoneOffset() * 60000;

  var cleanDate = new Date(date.getTime() + userTimezoneOffset);
  return cleanDate;
}
export function toArrayOfString(a) {
  if (a) {
    var arrObj = [];
    var arr = a.toString().split(",");
    arr.forEach(s => {
      arrObj.push(s.toString());
    });
    return arrObj;
  } else {
    return [];
  }
}
export function capitalizeItems(item_list, itemText, itemValue, fields) {
  var items = [];
  if (!Array.isArray(item_list)) {
    item_list = item_list.split(",");
  }
  if (item_list) {
    item_list.forEach(function(it) {
      // var str_item = it.toString();
      var i = {};

      if (typeof it == "object") {
        if (itemText) {
          if (fields) {
            fields.forEach(f => {
              i[f] = it[f];
            });
          } else {
            i = it;
          }
          // i = it;
          if (itemText.indexOf(",") > -1) {
            var combItems = itemText.split(",");
            var text = [];

            combItems.forEach(i => {
              text.push(capitalize(it[i]));
            });
            i["text"] = text.join(" ");
          } else {
            i["text"] = capitalize(it[itemText]);
          }

          i["value"] = it[itemValue];
          items.push(i);
        }
      } else {
        i["value"] = it;
        i["text"] = capitalize(it);
        items.push(i);
      }

      // it = i;
    });
  }

  return items;
}

export function getObjectPathByKey(obj, key) {
  var o = null;
  Object.keys(obj).forEach(function(k) {
    if (k == key) {
      o = obj[k];
    }
    if (!o) {
      if (obj[k] && typeof obj[k] == "object" && !Array.isArray(obj[k])) {
        // path.push(k);
        o = getObjectPathByKey(obj[k], key);
      }
    } else {
      path.push(k);
    }
  });

  if (o) {
    return path;
  }
}
export function normalizePath(path) {
  return path.replace(/\\/g, "/").replace(/\/{2,}/g, "/");
}

export function isMobile() {
  if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
    return true;
  }
  return false;
}

export function addKeyToObject(obj, key, value, index) {
  // Create a temp object and index variable
  var temp = {};
  var i = 0;

  // Loop through the original object
  for (var prop in obj) {
    if (obj.hasOwnProperty(prop)) {
      // If the indexes match, add the new item
      if (i === index && key && value) {
        temp[key] = value;
      }

      // Add the current item in the loop to the temp obj
      temp[prop] = obj[prop];

      // Increase the count
      i++;
    }
  }
  return temp;
}

export function getKeyIndex(obj, key) {
  var i = 0;
  for (var prop in obj) {
    if (prop == key) {
      return i;
    }
    i++;
  }
  return i;
}

export function updateObjectByPath(obj, p, newValue) {
  var thisObj = null;
  p.forEach(function(k, i) {
    thisObj = obj[k];
    if (i == p.length - 1) {
      thisObj[k] = newValue;
    }
  });
}

export function guid() {
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  }

  return s4() + s4() + s4() + s4() + s4() + s4(); //+ s4() + s4();
}
export function timeStamp() {
  return formatDate(new Date(), false, true, true);
}
export function getParameterByName(name) {
  name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
  var regexS = "[\\?&]" + name + "=([^&#]*)";
  var regex = new RegExp(regexS);
  var results = regex.exec(window.location.search);
  if (results == null) return "";
  else return decodeURIComponent(results[1].replace(/\+/g, " "));
}
export function getHost() {
  return `${window.location.protocol}//${window.location.hostname}`;
}
export function getCurrentDateTime(time) {
  var d = new Date();
  var today = parseInt(d.getMonth()) + 1 + "/" + d.getDate() + "/" + d.getFullYear();
  if (time) {
    today += " " + d.getHours() + ":" + d.getMinutes();
  }
  return today;
}
export function moveUp(element, parent) {
  if (element.previousElementSibling) parent.insertBefore(element, element.previousElementSibling);
}
export function moveDown(element, parent) {
  // if(element.nextElementSibling)
  parent.insertBefore(element.nextElementSibling, element);
}
export function InArray(arr, prop, value) {
  var exist = false;
  arr.forEach(e => {
    if (e[prop] == value) {
      exist = true;
    }
  });
  return exist;
}
export function formatPercent(percent) {
  return (percent * 100).toLocaleString(undefined, {
    style: "percent",
    minimumFractionDigits: 2
  });
}

export function capitalize(s) {
  if (!s) return "";
  if (typeof s != "string") {
    return s;
  }
  var capStr = [];

  if (s.endsWith("ID")) {
    return s;
  }

  s.toString()
    .split(",")
    .forEach(str => {
      try {
        var strCap = str.match(/[A-Z][a-z]+/g);

        str = str.replaceAll("_", " ");
        var splitStr = str.toLowerCase().split(" ");
        if (splitStr.length < 2) {
          splitStr = strCap;
        }

        for (var i = 0; i < splitStr.length; i++) {
          splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
        }

        capStr.push(" " + splitStr.join(" "));
      } catch (error) {
        // console.log(error);
        capStr.push("");
      }
    });
  return capStr.join(",") ? capStr.join(",").trim() : s.title() || s.title();
}

String.prototype.title = function() {
  return this.charAt(0).toUpperCase() + this.slice(1);
};

export function findParent(obj, prop) {
  var parent = obj.$parent;
  if (parent[prop]) {
    return parent;
  } else {
    if (parent) {
      parent = findParent(parent, prop);
    } else {
      return null;
    }
  }
  return parent;
}
export function detectCreditCardType(cardNumber) {
  const patterns = {
    visa: /^4\d{12}(?:\d{3})?$/,
    mastercard: /^5[1-5]\d{14}$/,
    amex: /^3[47]\d{13}$/,
    discover: /^6(?:011|5[0-9]{2})[0-9]{12}$/
  };

  let cardType = null;
  let digits = null;

  Object.keys(patterns).forEach(type => {
    if (patterns[type].test(cardNumber)) {
      cardType = type;
      digits = type === "amex" ? "15" : "16";
    }
  });

  return { cardType, digits };
}

export function removeHtmlComments(inputStr) {
  try {
    return inputStr.replace(/<!--[\s\S]*?-->/g, "");
  } catch (error) {
    return inputStr;
  }
}
export function sortPropertiesInObject(obj) {
  // Function to check if a value is a plain object
  const isObject = value => value && typeof value === "object" && !Array.isArray(value);

  // Return as-is if obj is null, undefined, or not an object
  if (!isObject(obj)) {
    return obj === undefined || obj === null ? {} : obj;
  }

  // Recursive sort function
  const sortObj = o => {
    const sortedObj = Object.keys(o)
      .sort()
      .reduce((result, key) => {
        if (isObject(o[key])) {
          result[key] = sortObj(o[key]);
        } else {
          result[key] = o[key];
        }
        return result;
      }, {});
    return sortedObj;
  };

  return sortObj(obj);
}

export function getValueFromPath(obj, path) {
  return path.split(".").reduce((acc, part, index, arr) => {
    if (acc === undefined || acc === null) return undefined;
    if (/^\d+$/.test(part)) part = parseInt(part); // Convert to integer if it's an array index
    return acc[part];
  }, obj);
}
export function updateValueAtPath(obj, path, newValue) {
  const keys = path.split(".");
  keys.reduce((acc, key, index) => {
    if (acc === undefined || acc === null) return undefined;
    if (/^\d+$/.test(key)) key = parseInt(key); // Convert to integer if it's an array index

    if (index === keys.length - 1) {
      acc[key] = newValue; // Update the value at the last key
    }
    return acc[key];
  }, obj);
}
export function isObjectAndNotEmpty(obj) {
  return obj !== null && typeof obj === "object" && Object.keys(obj).length > 0;
}
export function deepFind(obj, path) {
  var paths = path.split("."),
    current = obj;
  //   i;

  // for (i = 0; i < paths.length; ++i) {
  //   if (current[paths[i]] == undefined) {
  //     return undefined;
  //   } else {
  //     current = current[paths[i]];
  //   }
  // }
  paths.forEach(function(p) {
    if (current) {
      current = current[p];
    }

    // if (p == paths[paths.length - 1] && value) {
    //   current = value;
    // }

    // if (i == paths.length - 1 && value) {
    //   return obj;
    // }
  });

  return current;
  // if(value){

  // }
}

export function copyObject(a, b) {
  Object.keys(a).forEach(function(p) {
    b[p] = a[p];
  });
}
var allPath = [];
export function getPath(object, previousPath) {
  for (var key in object) {
    let currentPath = previousPath ? `${previousPath}.${key}` : key;

    if (Array.isArray(object[key])) {
      // console.log(currentPath)
      // console.log(object[key].type)
      // if (object[key].type == "object") {
      //   console.log(key)
      // }
      getPath(object[key], currentPath);
    } else if (typeof object[key] === "object") {
      if (!Array.isArray(object)) {
        // skipping logging array keys like children.0
        console.log(currentPath);
        if (object[key].type == "object") {
          console.log(key, "object");
        }
        // console.log("objType", object[key].type)
        allPath.push(currentPath);
      }
      getPath(object[key], currentPath);
    } else {
      allPath.push(currentPath);
    }
  }
  return allPath;
}
export function sum(r, formula) {
  var arr = r;
  var total = 0;
  if (arr && Array.isArray(arr)) {
    arr.forEach(f => {
      // console.log(f);
      total += parseFloat(eval(formula)) || 0;
    });
  }

  return total;
}
export function sumOf(r, field) {
  var arr = r;
  var total = 0;
  if (arr && Array.isArray(arr)) {
    arr.forEach(f => {
      // console.log(f);
      total += parseFloat(f[field]) || 0;
    });
  }

  return total;
}
export function prepend(value, array) {
  var newArray = array.slice();
  newArray.unshift(value);
  return newArray;
}
export function extractJsonFromString(str) {
  try {
    str = str.replaceAll("\n", "").replace(/\}\s+\}/g, "}}");
    // var matches = str.match(/(\{.*?\})[^}|,]/g);
    var ptrn = /(\{.*?\})[^}|,]/g;
    var match;
    var formatObject = function(obj, tbl, parentLabel) {
      Object.keys(obj).forEach((r, i) => {
        var t = capitalize(r);
        var v = obj[r];
        if (typeof v === "object") {
          tbl += "<b>" + t + "</b>:<br>" + formatObject(v, tbl, t);
        } else {
          tbl += "<b>" + t + ": </b>";
          if (isNaN(v)) {
            v = capitalize(obj[r]);
          }

          tbl += v;
          tbl += "<br>";
        }
      });
      return tbl;
    };

    while ((match = ptrn.exec(str)) != null) {
      try {
        var m = match[1];
        // console.log(match);
        // console.log(m);
        var obj = JSON.parse(m);
        var tbl = "";
        tbl = formatObject(obj, tbl);
        // style='text-align:left'
        var div = "<div>" + tbl + "</div>";

        str = str.replace(m, div);
      } catch (error) {
        //
      }
    }

    return str;
  } catch (error) {
    return error;
  }
}

export function siteLocation() {
  var url = location.protocol + "//" + location.hostname;
  if (window.location.host.indexOf("localhost") != -1) {
    url += ":" + location.port;
  }
  return url;
}

export function getMustache(template, data) {
  var makeTable2 = function(k) {
    var t = data[k];
    var table = "<table  style='width:100%; border-collapse: collapse;border-spacing: 0;'>";
    var header = "<tr>";
    var headerRow = 0;
    var i = 0;
    t.forEach((r, j) => {
      var fCnt = Object.keys(r).length;
      if (fCnt > headerRow) {
        headerRow = fCnt;
        i = j;
      }
    });

    Object.keys(t[i]).forEach(h => {
      if (h != "_id") {
        header += "<th style='border:solid 1px; padding:2px'>" + capitalize(h) + "</th>";
      }
    });
    header += "</tr>";
    table += header;

    t.forEach(r => {
      var row = "<tr>";
      Object.keys(t[i]).forEach(h => {
        if (h != "_id") {
          var d = r[h] || "&nbsp;";
          row += "<td style='text-align:right;border:solid 1px; padding:2px'>" + d + "</td>";
        }
      });
      row += "</tr>";
      table += row;
    });
    table += "</table>";
    return table;
  };
  var tables = [];

  var makeTable = function(k) {
    var t = data[k];
    var table = "<table  style='width:100%; border-collapse: collapse;border-spacing: 0;'>";
    var header = "<tr>";
    var headerRow = 0;
    var i = 0;
    t.forEach((r, j) => {
      var fCnt = Object.keys(r).length;
      if (fCnt > headerRow) {
        headerRow = fCnt;
        i = j;
      }
    });

    Object.keys(t[i]).forEach(h => {
      if (h != "_id") {
        header += "<th style='border:solid 1px; padding:2px'>" + capitalize(h) + "</th>";
      }
    });
    header += "</tr>";
    table += header;

    t.forEach(r => {
      var row = "<tr>";
      Object.keys(t[i]).forEach(h => {
        if (h != "_id") {
          var d = r[h] || "&nbsp;";
          row += "<td style='text-align:right;border:solid 1px; padding:2px'>" + d + "</td>";
        }
      });
      row += "</tr>";
      table += row;
    });
    table += "</table>";
    return table;
  };

  // Object.keys(data).forEach((k) => {
  // var re=/{{([\:\/\-\\\,\.a-zA-Z0-9\s])*}}/g
  var re = /{{(.*?)}}/g;
  var tags = template.match(re);
  var parentTags = tags.filter(t => {
    return t.indexOf(".") != -1;
  });
  tags = tags.filter(t => {
    return t.indexOf(".") == -1;
  });
  tags.forEach(t => {
    re = /{{(.*?)}}/;
    var m = re.exec(t);
    if (m) {
      var f = m[1];
      template = template.replaceAll(t, data[f] || "");
    }

    parentTags.forEach(t => {
      re = /{{(.*?)}}/;
      var m = re.exec(t);
      if (m) {
        var l = m[1].split(".");
        var parent = l[0];
        if (!tables.includes(parent)) {
          if (Array.isArray(data[parent])) {
            tables.push(parent);
            var fields = parentTags.filter(p => {
              var par = re.exec(p)[1].split(".");
              return par[0] == parent;
            });
            var fieldNames = [];
            fields.forEach(f => {
              fieldNames.push(re.exec(f)[1].split(".")[1]);
            });
            var tblData = data[parent];
            var rowRe = "<tr[^>]*>((?!<\\/tr)[\\s\\S])*" + parent + ".[\\s\\S]*?<\\/tr>";
            var re1 = new RegExp(rowRe, "g");

            var modelRow = template.match(re1);
            var newRows = "";

            var cellRe = "{{" + parent + ".(.*)}}";
            var re2 = new RegExp(cellRe, "g");
            var modelCells = modelRow[0].match(re2);
            // console.log(modelCells);
            var cells = [];
            modelCells.forEach(c => {
              cells.push(c);
            });

            tblData.forEach(r => {
              var row = modelRow[0];
              cells.forEach(c => {
                var cell = c.match(re)[1];
                var data = r[cell.split(".")[1]] || "";
                row = row.replace(c, data);
              });

              newRows += row;
            });
            template = template.replace(modelRow[0], newRows);
          }
        }
      }
    });
  });

  /* eslint-disable no-useless-escape */
  template = template.replace(/{{.*?}}/g, "");
  return template;
}

export function getSum(a) {
  var total = 0;
  try {
    Object.keys(a).forEach(function(k) {
      if (a[k] && !a[k].isNaN) {
        total += parseFloat(a[k]);
      }
    });
  } catch (error) {
    // console.log(error);
  }

  return total;
}
export function getCount(a) {
  var total = 0;
  try {
    Object.keys(a).forEach(function(k) {
      if (a[k] && !a[k].isNaN) {
        total += parseFloat(a[k]);
      }
    });
  } catch (error) {
    // console.log(error);
  }

  return total;
}
export function calculateInventoryVolume(inventory) {
  // var inventory = this.data_object.model.inventory;
  if (!inventory) {
    inventory = [];
  }
  // that.data_object.model.inventory_volume = 0;
  var inventory_volume = 0;
  if (inventory && inventory.length) {
    inventory.forEach(i => {
      if (i.volume && i.qty) {
        inventory_volume += parseFloat(i.volume) * parseInt(i.qty);
      }
    });
    return inventory_volume;
  }
}
export function concatenateArrays(array1, array2) {
  let uniqueIds = new Set();

  let result = [];

  // Add all items from array1 to result
  for (let item of array1) {
    if (!uniqueIds.has(item._id)) {
      uniqueIds.add(item._id);
      result.push(item);
    }
  }

  // Add items from array2 to result only if they have a unique _id
  for (let item of array2) {
    if (!uniqueIds.has(item._id)) {
      uniqueIds.add(item._id);
      result.push(item);
    }
  }

  return result;
}
export function format(string, ...args) {
  if (args.length === 0) {
    return string;
  }

  return string.replace(/{(\d+)}/g, (match, index) => {
    if (typeof args[index] !== "undefined") {
      return args[index];
    }
    return match;
  });
}
String.prototype.format = function() {
  var i = 0,
    args = arguments;
  return this.replace(/{}/g, function() {
    return typeof args[i] != "undefined" ? args[i++] : "";
  });
};
Date.prototype.addHours = function(h) {
  this.setTime(this.getTime() + h * 60 * 60 * 1000);
  return this;
};
Date.prototype.addMinutes = function(m) {
  this.setTime(this.getTime() + m * 60 * 1000);
  return this;
};
Date.prototype.addDays = function(h) {
  this.setDate(this.getDate() + h);
  return this;
};
export function filterObjectByProperties(obj, properties, excluded) {
  var myObj = clone(obj);
  Object.keys(obj.properties).forEach(function(k) {
    if (excluded) {
      if (properties.includes(k)) {
        delete myObj.properties[k];
      }
    } else {
      if (!properties.includes(k)) {
        delete myObj.properties[k];
      }
    }
  });
  return myObj;
}
export function getWeekDate(date) {
  if (!date) {
    date = new Date();
  } else {
    date = new Date(date);
  }
  var days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
  return days[date.getDay()];
}
export function getMonthName1(date) {
  if (!(date instanceof Date)) {
    date = new Date(date);
  }
  return date.toLocaleString("default", { month: "short" });
}
export function getMonthName(n, date, short) {
  var months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ];
  if (!n) {
    n = 0;
  }
  if (!date) {
    date = new Date();
    date = fixDate(new Date(date));
  }

  var mNumber = date.getMonth() + n;
  if (mNumber == -1) {
    mNumber = 11;
  }

  return short ? months[mNumber].substring(0, 3) : months[mNumber];
}
export function formatNumber(number) {
  return number.toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
  // return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
export function formatFullDate(date, noFix) {
  if (!date) return null;
  var myDate = new Date(date);
  if (!noFix) {
    myDate = fixDate(new Date(date));
  }
  return `${getWeekDate(myDate)}, ${getMonthName(0, myDate)} ${myDate.getDate()}, ${myDate.getFullYear()}`;
}
export function evalJson(json, f) {
  if (typeof json === "string") {
    try {
      // Try to evaluate the string as JavaScript code
      const evaluated = eval(json);
      return evaluated;
    } catch (error) {
      // If the string is not valid JavaScript code, return it as is
      return json;
    }
  } else if (Array.isArray(json)) {
    // If the current value is an array, recursively evaluate each item in the array
    return json.map(evalJson, f);
  } else if (typeof json === "object" && json !== null) {
    // If the current value is an object, recursively evaluate each property value
    const evaluated = {};
    for (const [key, value] of Object.entries(json)) {
      evaluated[key] = evalJson(value, f);
    }
    return evaluated;
  } else {
    // If the current value is not a string, array or object, return it as is
    return json;
  }
}
export function modifyDate(modifier, date) {
  if (date) {
    date = new Date(date);
  } else {
    date = new Date();
  }

  if (modifier) {
    if (typeof modifier == "object") {
      var unit = Object.keys(modifier)[0];
      var amount = modifier[unit];
      switch (unit) {
        case "minute":
          date.setMinutes(date.getMinutes() + amount);
          break;
        case "hour":
          date.setHours(date.getHours() + amount);
          break;
        case "day":
          date.setDate(date.getDate() + amount);
          break;
        case "month":
          date.setMonth(date.getMonth() + amount);
          break;
        case "year":
          date.setFullYear(date.getFullYear() + amount);
          break;
        default:
        // throw new Error(`Invalid modifier unit: ${modifier.unit}`);
      }
    }

    return formatDate(date, false, true, true);
  } else {
    return formatDate(date, false, false, true);
  }
}
export function getCurrentTime(myDate) {
  return `${padZero(myDate.getHours())}:${padZero(myDate.getMinutes())}`;
}
export function convertDateStringToISO(dateStr) {
  const [month, day, year] = dateStr.split("/").map(Number);
  const mm = String(month).padStart(2, "0");
  const dd = String(day).padStart(2, "0");
  return `${year}-${mm}-${dd}`;
}
export function convertDateObjectToISO(date) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0"); // getMonth is 0-based
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}
export function getDeep(item, path) {
  return path.split(".").reduce((obj, key) => {
    return obj ? obj[key] : undefined;
  }, item);
}
export function isDMYTime(str) {
  if (typeof str !== "string") return false;

  const re = /^(\d{1,2})\/(\d{1,2})\/(\d{4}) (\d{2}):(\d{2})(?::(\d{2}))?$/;
  const m = str.match(re);
  if (!m) return false;

  const [, d, mo, y, h, mi, s] = m.map(Number);

  // basic range checks
  if (mo < 1 || mo > 12) return false;
  if (d < 1 || d > 31) return false;
  if (h > 23 || mi > 59 || (s != null && s > 59)) return false;

  // real date check (catches 31/2, 30/2, etc.)
  const dt = new Date(y, mo - 1, d, h, mi, s || 0);
  return dt.getFullYear() === y && dt.getMonth() === mo - 1 && dt.getDate() === d;
}

export function formatDate(date, standard, time, noFix, sec, pad, noDefaultDate, AM) {
  var myDate;
  if (!date || date == "None" || date.toString().trim() == "") {
    if (noDefaultDate) {
      myDate = new Date();
    }
  } else {
    myDate = new Date(date);
  }

  if (!noFix) {
    myDate = fixDate(myDate);
  }

  if (!myDate) return date;
  var d = "";
  if (!standard) {
    d = `${myDate.getMonth() + 1}/${myDate.getDate()}/${myDate.getFullYear()}`;
    if (pad) {
      d = `${padZero(myDate.getMonth() + 1)}/${padZero(myDate.getDate())}/${myDate.getFullYear()}`;
    }
  } else {
    d = `${myDate.getFullYear()}-${padZero(myDate.getMonth() + 1)}-${padZero(myDate.getDate())}`;
  }
  if (time) {
    if (AM) {
      d += " " + ampm(myDate.getHours(), myDate.getMinutes());
    } else {
      d += ` ${padZero(myDate.getHours())}:${padZero(myDate.getMinutes())}`;
      if (sec) {
        d += ":" + padZero(myDate.getSeconds());
      }
    }
  }

  return d;
}

export function formatDateToISO(date) {
  if (!(date instanceof Date)) {
    console.error("Invalid Date object");
    return null;
  }
  const year = date.getUTCFullYear();
  const month = String(date.getUTCMonth() + 1).padStart(2, "0"); // Months are 0-based
  const day = String(date.getUTCDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}
export function fixDate(d) {
  var europeanDateFormat = false;
  if (localStorage["portal_settings"] && localStorage["portal_settings"] != "undefined") {
    europeanDateFormat = JSON.parse(localStorage["portal_settings"])[0]["european_date_format"];
  }

  if (d) {
    if (!europeanDateFormat) {
      var actualDate = new Date(d.getTime() - d.getTimezoneOffset() * -60000);
      return actualDate;
    }
    return new Date(d);
  }
}
export function rgbToHex(r, g, b) {
  return "#" + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
}

export function hexToRgb(hex) {
  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  if (result) {
    var r = parseInt(result[1], 16);
    var g = parseInt(result[2], 16);
    var b = parseInt(result[3], 16);
    return r + "," + g + "," + b; //return 23,14,45 -> reformat if needed
  }
  return null;
}
export function addHoursToTime(timeStr, hoursToAdd) {
  if (!timeStr) return null;

  let [hour, minute] = timeStr.split(":").map(n => parseInt(n, 10));

  hour += parseFloat(hoursToAdd);

  // wrap around 24h
  if (hour >= 24) hour = hour % 24;
  if (hour < 0) hour = 24 + hour;

  return `${hour.toString().padStart(2, "0")}:${minute.toString().padStart(2, "0")}`;
}

export function preprocessJsonForMongoDB(jsonStr) {
  /**
   * Converts a JSON string with ISODate(...) into a valid JSON format,
   * parses it into an object, and ensures date comparisons are properly converted.
   */

  // Step 1: Replace ISODate("...") with "..." (valid JSON)
  jsonStr = jsonStr.replace(/ISODate\("([^"]+)"\)/g, '"$1"');

  // Step 2: Parse JSON into JavaScript object
  let queryObj;
  try {
    queryObj = JSON.parse(jsonStr);
  } catch (error) {
    throw new Error("Invalid JSON format: " + error.message);
  }
  return queryObj;
}
export function mongoToSqlLike(query) {
  function processCondition(field, condition) {
    if (typeof condition !== "object" || condition === null) {
      return `${field} = ${JSON.stringify(condition)}`;
    }

    const conditions = [];
    if (condition.$eq !== undefined) {
      conditions.push(`${field} = ${JSON.stringify(condition.$eq)}`);
    }
    if (condition.$ne !== undefined) {
      conditions.push(`${field} != ${JSON.stringify(condition.$ne)}`);
    }
    if (condition.$gt !== undefined) {
      conditions.push(`${field} > ${JSON.stringify(condition.$gt)}`);
    }
    if (condition.$gte !== undefined) {
      conditions.push(`${field} >= ${JSON.stringify(condition.$gte)}`);
    }
    if (condition.$lt !== undefined) {
      conditions.push(`${field} < ${JSON.stringify(condition.$lt)}`);
    }
    if (condition.$lte !== undefined) {
      conditions.push(`${field} <= ${JSON.stringify(condition.$lte)}`);
    }
    if (condition.$exists === true) {
      conditions.push(`${field} EXISTS`);
    }
    if (condition.$exists === false) {
      conditions.push(`${field} NOT EXISTS`);
    }
    if (condition.$regex) {
      conditions.push(`${field} LIKE '%${condition.$regex.replace(/^\/|\/$/g, "")}%'`);
    }
    return conditions.join(" AND ");
  }

  function parseLogicalOperator(op, conditions) {
    const parsedConditions = conditions.map(mongoToSqlLike).filter(Boolean);
    return `(${parsedConditions.join(` ${op.toUpperCase()} `)})`;
  }

  function parseExpr(expr) {
    // If $expr contains $and, process it as a logical AND group.
    if (expr.$and) {
      return parseLogicalOperator("AND", expr.$and);
    }

    // Check for date comparisons directly if $and is not present.
    if (Array.isArray(expr.$gte) && Array.isArray(expr.$lt)) {
      const gteDate = expr.$gte[1]?.$dateFromString?.dateString || expr.$gte[1];
      const ltDate = expr.$lt[1]?.$dateFromString?.dateString || expr.$lt[1];
      if (gteDate && ltDate) {
        return `date BETWEEN '${gteDate}' AND '${ltDate}'`;
      }
    }

    return null;
  }

  function parseQuery(queryObj) {
    const sqlConditions = [];
    for (const [key, value] of Object.entries(queryObj)) {
      if (key === "$and") {
        sqlConditions.push(parseLogicalOperator("AND", value));
      } else if (key === "$or") {
        sqlConditions.push(parseLogicalOperator("OR", value));
      } else if (key === "$expr") {
        const exprCondition = parseExpr(value);
        if (exprCondition) {
          sqlConditions.push(exprCondition);
        }
      } else {
        sqlConditions.push(processCondition(key, value));
      }
    }
    return sqlConditions.join(" AND ");
  }

  return parseQuery(query);
}

export function calculateLuminance(color) {
  // Implementation of luminance calculation (you can use your own method or library)
  // For simplicity, this example assumes the color is in hexadecimal format
  if (!color) {
    color = "FFFFFF";
  }
  const hexColor = color.replace("#", "");
  const r = parseInt(hexColor.substr(0, 2), 16);
  const g = parseInt(hexColor.substr(2, 2), 16);
  const b = parseInt(hexColor.substr(4, 2), 16);
  // return (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  // console.log(luminance)
  const textColor = luminance > 0.6 ? "#000000" : "#FFFFFF";

  return textColor;
}
export function invertColor(hex) {
  // Remove the hash (#) if it's there
  hex = hex.replace(/^#/, "");

  // Parse r, g, b values
  let r = parseInt(hex.substring(0, 2), 16);
  let g = parseInt(hex.substring(2, 4), 16);
  let b = parseInt(hex.substring(4, 6), 16);

  // Invert each channel
  r = 255 - r;
  g = 255 - g;
  b = 255 - b;

  // Convert to hex and ensure two digits
  r = r.toString(16).padStart(2, "0");
  g = g.toString(16).padStart(2, "0");
  b = b.toString(16).padStart(2, "0");

  // Return the inverted color with #
  return `#${r}${g}${b}`;
}
// export function invertColor(hex) {
//   // hex = rgbToHex(hexToRgb(hex));
//   // var col = hex.replace("#", "").toLowerCase();
//   // const colors = [
//   //   "0",
//   //   "1",
//   //   "2",
//   //   "3",
//   //   "4",
//   //   "5",
//   //   "6",
//   //   "7",
//   //   "8",
//   //   "9",
//   //   "a",
//   //   "b",
//   //   "c",
//   //   "d",
//   //   "e",
//   //   "f",
//   // ];
//   // let inverseColor = "#";
//   // col
//   //   .replace("#", "")
//   //   .split("")
//   //   .forEach((i) => {
//   //     const index = colors.indexOf(i);
//   //     inverseColor += colors.reverse()[index];
//   //   });
//   // return inverseColor;
//   // hex = hex.replace("#", "");
//   // return (Number(`0x1${ hex } `) ^ 0xffffff)
//   //   .toString(16)
//   //   .substr(1)
//   //   .toUpperCase();
//   if (hex.indexOf("#") === 0) {
//     hex = hex.slice(1);
//   }
//   // convert 3-digit hex to 6-digits.
//   if (hex.length === 3) {
//     hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
//   }
//   if (hex.length == 8) {
//     hex = hex.substring(0, hex.length - 2);
//   }
//   // invert color components
//   var r = (255 - parseInt(hex.slice(0, 2), 16)).toString(16),
//     g = (255 - parseInt(hex.slice(2, 4), 16)).toString(16),
//     b = (255 - parseInt(hex.slice(4, 6), 16)).toString(16);
//   // pad each with zeros and return
//   return "#" + padZero(r) + padZero(g) + padZero(b);
// }

export function getItineraryIcon(t) {
  switch (t) {
    case "d":
      return "home";

    case "w":
      return "warehouse";

    case "p":
      return "ferry";

    default:
      break;
  }
}
export function getReadableTextColor(hex) {
  // Remove the hash (#) if it's there
  hex = hex.replace(/^#/, "");

  // Parse r, g, b values
  let r = parseInt(hex.substring(0, 2), 16);
  let g = parseInt(hex.substring(2, 4), 16);
  let b = parseInt(hex.substring(4, 6), 16);

  // Calculate the luminance (relative brightness)
  // Use the standard formula: L = 0.299*R + 0.587*G + 0.114*B
  const luminance = 0.299 * r + 0.587 * g + 0.114 * b;

  // If luminance is lower than a certain threshold, return white, else return black
  return luminance < 128 ? "#FFFFFF" : "#000000";
}
export function showTime(s) {
  var t = new Date();

  return (
    t.getMonth() +
    1 +
    "/" +
    t.getDate() +
    "/" +
    t.getFullYear() +
    " " +
    padZero(t.getHours()) +
    ":" +
    padZero(t.getMinutes()) +
    ":" +
    padZero(t.getSeconds())
  );
}
export function padZero(str, len) {
  len = len || 2;
  var zeros = new Array(len).join("0");
  return (zeros + str).slice(-len);
}
export function getTime(date) {
  if (!date) return null;
  var myDate = new Date(date);
  if (!myDate) return date;

  return pad(myDate.getHours(), 2) + ":" + pad(myDate.getMinutes(), 2);
}
export function decodeHtml(html) {
  var txt = document.createElement("textarea");
  txt.innerHTML = html;
  return txt.value;
}
export function dateDifference(d1, d2, isTime) {
  const date1 = new Date(d1);
  const date2 = new Date(d2);
  const diffTime = date2 - date1;
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  if (isTime) {
    return diffTime;
  }
  return diffDays;
}
export function removeDuplicates(array, propertyName) {
  const unique = new Set();
  return array.filter(item => {
    const isDuplicate = unique.has(item[propertyName]);
    unique.add(item[propertyName]);
    return !isDuplicate;
  });
}
export function groupBy(xs, key) {
  return xs.reduce(function(rv, x) {
    (rv[x[key]] = rv[x[key]] || []).push(x);
    return rv;
  }, {});
}
export function roundTime(time) {
  var hours, minutes;
  hours = parseInt(time.split(":")[0]);
  minutes = parseInt(time.split(":")[1]);
  var m = ((((minutes + 7.5) / 15) | 0) * 15) % 60;
  var h = (((minutes / 105 + 0.5) | 0) + hours) % 24;
  return h + ":" + m;
}

export function formattedDateTime(dateTime, defaultTime) {
  if (!dateTime) {
    return "";
  }
  dateTime = dateTime.toString().trim();
  var date = dateTime.split(" ")[0] || dateTime;
  date = formatDate(date);
  var time = dateTime.split(" ").length > 1 ? dateTime.split(" ")[1] : defaultTime || "";
  var t = time.split(":");
  if (t.length == 3) {
    t.splice(2, 1);
    time = t.join(":");
  }
  return date + " " + time;
}
export function getFullDate(d) {
  return d.getMonth() + 1 + "/" + d.getDate() + "/" + d.getFullYear();
}
export function formatDateTime(date, noTime) {
  if (!date) return null;
  var myDate = new Date(date);
  if (!myDate) return date;
  var formattedDate = myDate.getFullYear() + "-" + pad(myDate.getMonth() + 1, 2) + "-" + pad(myDate.getDate(), 2);
  if (!noTime) {
    formattedDate += " " + pad(myDate.getHours(), 2) + ":" + pad(myDate.getMinutes(), 2) + ":00";
  }
  if (formattedDate == "NaN-NaN-NaN NaN:NaN:00" || formattedDate == "NaN-NaN-NaN") {
    return null;
  }

  return formattedDate;
}

export function pad(num, size) {
  num = num.toString();
  while (num.length < size) num = "0" + num;
  return num;
}
export function formatDateTimeHere(d) {
  d = formatDateTime(d);
  var timeZone = new Date(d);
  timeZone = timeZone.getTimezoneOffset() / -60;
  var plusMinus = timeZone >= 0 ? "+" : "=";
  timeZone = pad(timeZone, 2);
  d = d.replace(" ", "T"); //+ plusMinus + timeZone;
  return d;
}
export function objectEqual(a, b, ignoreField) {
  var equal = true;
  // if (Object.keys(a).length != Object.keys(b).length) {
  //   return false;
  // }
  Object.keys(a).forEach(o => {
    var val1 = a[o] || "";
    var val2 = b[o] || "";
    if (val1 != val2 && o != ignoreField) {
      equal = false;
    }
  });
  Object.keys(b).forEach(o => {
    var val1 = a[o] || "";
    var val2 = b[o] || "";
    if (val1 != val2 && o != ignoreField) {
      equal = false;
    }
  });
  return equal;
}
Array.prototype.move = function(from, to) {
  this.splice(to, 0, this.splice(from, 1)[0]);
};
export function removeElementsByClass(className) {
  const elements = document.getElementsByClassName(className);
  while (elements.length > 0) {
    elements[0].parentNode.removeChild(elements[0]);
  }
}
Element.prototype.insertChildAtIndex = function(child, index) {
  if (!index) index = 0;
  if (index >= this.children.length) {
    this.appendChild(child);
  } else {
    this.insertBefore(child, this.children[index]);
  }
};
export function ampm(hrs, min) {
  if (!min) {
    min = 0;
  }
  var amPm = "AM";
  if (hrs > 12 && hrs < 24) {
    hrs = hrs - 12;
    amPm = "PM";
  } else if (hrs == 12) {
    amPm = "PM";
  } else if (hrs == 24) {
    hrs = 12;
    amPm = "AM";
  }

  return padZero(hrs) + ":" + padZero(min) + " " + amPm;
}
export function formatTime(d, ampm) {
  var date = new Date(d);
  // date = fixDate(new Date(date));
  var hrs = date.getHours();
  var min = padZero(date.getMinutes());
  if (!ampm) {
    return hrs + ":" + min;
  } else {
    var amPm = "";
    if (hrs > 12) {
      hrs = hrs - 12;
      amPm = "p";
    } else if (hrs == 12) {
      amPm = "p";
    }
    return hrs + ":" + min + amPm;
  }
}
export function randomColor() {
  return Math.floor(Math.random() * 16777215).toString(16);
}
export function getObjectIndexInArray(arr, key, value) {
  var ind = -1;
  arr.forEach((a, i) => {
    if (a[key] == value) {
      ind = i;
    }
  });
  return ind;
}
export function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}
export function waitForElm(selector) {
  return new Promise(resolve => {
    if (document.querySelector(selector)) {
      return resolve(document.querySelector(selector));
    }

    const observer = new MutationObserver(mutations => {
      if (document.querySelector(selector)) {
        resolve(document.querySelector(selector));
        observer.disconnect();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  });
}

export function parseTemplate(template, model) {
  return template.replace(/\{\{(.*?)\}\}/g, (_, path) => {
    try {
      return (
        path
          .trim()
          .split(".")
          .reduce((o, k) => o?.[k], model) ?? ""
      );
    } catch {
      return "";
    }
  });
}
export function replaceLetterFields(model) {
  var r = JSON.parse(localStorage.getItem("letterFields"));

  Object.keys(r).forEach(f => {
    // if (f == "MyCompanyName") {
    //   console.log(f);
    // }
    if (r[f] && model) {
      model = model.toString().replaceAll(
        "|" + f + "|",
        // r[f] ? "{{model." + r[f] + "}}" : ""
        "{{model." + r[f] + "}}"
      );
    }
  });
  model = model.replaceAll("{{{", "}}");
  if (model == "[object Object]") {
    model = "<p></p>";
  }
  return model;
}
Date.prototype.addHours = function(h) {
  this.setTime(this.getTime() + h * 60 * 60 * 1000);
  return this;
};
export function mileage(latP, longP, latD, longD) {
  var c = 0.01745;
  var x =
    Math.sin(latP * c) * Math.sin(latD * c) + Math.cos(latP * c) * Math.cos(latD * c) * Math.cos((longD - longP) * c);
  if (x) {
    var mileage = Math.round(1.15 * 3963 * (Math.atan(-x / Math.sqrt(-x * x + 1.0000000000001)) + 2 * Math.atan(1)), 2);
  }
  return mileage;
}
